import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { Country } from './types'

export const fetchCountryList = async (params?: { abortCtrl?: AbortController | AbortSignal }) => {
  return wretchClient
    .url('/admin/1.0/countries')
    .signal(params?.abortCtrl)
    .get()
    .json<ListingResponse<Country>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
